<template>
  <div class="container">
    <div class="row">
      <p>{{ t('thcPotencycalculatorSectionDescription') }}</p>
      <div class="col-sm">
        <FixedUnitInput
          :inputLabel="t('percentageTHC')"
          v-model.number="percent"
          :unit="t('percent')"
        />
      </div>
      <div class="col-sm">
        <FixedUnitOutput
          :outputLabel="t('mgTHCPerGram')"
          :number="mg"
          :unit="t('mgPerGram')"
        />
      </div>
    </div>

    <hr/>

    <div class="row">
      <div class="col-sm">
        <FixedUnitInput
          :inputLabel="t('mgTHCPerGramInput')"
          v-model.number="mg1"
          :unit="t('mgPerGram')"
        />
      </div>
      <div class="col-sm">
        <FixedUnitOutput
          :outputLabel="t('percentageTHCOutput')"
          :number="percentage1"
          :unit="t('percent')"
        />
      </div>
    </div>

    <hr/>

    <div class="row">
      <div class="col-sm">
        <FixedUnitInput
          :inputLabel="t('productVolume')"
          v-model.number="totalVolume"
          :unit="t('milliliters')"
        />
        <FixedUnitInput
          :inputLabel="t('productDensity')"
          v-model.number="density"
          :unit="t('gramsPerMilliliter')"
        />
        <FixedUnitInput
          :inputLabel="t('totalTHC')"
          v-model.number="totalTHC"
          :unit="t('milligrams')"
        />
      </div>
      <div class="col-sm">
        <FixedUnitOutput
          :outputLabel="t('mgMLTHC')"
          :number="mgPerML"
          :unit="t('mgPerML')"
        />
        <FixedUnitOutput
          :outputLabel="t('mgGTHC')"
          :number="mgPerG"
          :unit="t('mgPerGram')"
        />
        <FixedUnitOutput
          :outputLabel="t('thcPercentageOutput')"
          :number="percentage2"
          :unit="t('percent')"
        />
      </div>
    </div>

    <hr/>

    <div class="row">
      <div class="col-sm">
        <FixedUnitInput
          :inputLabel="t('productWeight')"
          v-model.number="totalWeight"
          :unit="t('grams')"
        />
        <FixedUnitInput
          :inputLabel="t('totalTHC')"
          v-model.number="totalTHC"
          :unit="t('milligrams')"
        />
      </div>
      <div class="col-sm">
        <FixedUnitOutput
          :outputLabel="t('mgTHCPerGramOutput')"
          :number="mgPerGram"
          :unit="t('mgPerGram')"
        />
        <FixedUnitOutput
          :outputLabel="t('thcPercentageOutput')"
          :number="thcPercentage"
          :unit="t('percent')"
        />
      </div>
    </div>

  </div>
</template>

  
  <script>
  import { ref, computed, reactive } from 'vue';
  import { useI18n } from 'vue-i18n';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue'; // Ensure correct import path
  import FixedUnitOutput from '../inputs/FixedUnitOutput.vue'; // Ensure correct import path
  import { defaultRound } from '../../utils/math'; // Adjust the import path
  
  export default {
    components: {
      FixedUnitInput,
      FixedUnitOutput
    },
    setup() {

        const { t } = useI18n();

        // Create a reactive object with a function
        const translations = reactive({
          t: (key) => t(key)
        })

        const percent = ref(19);
        const mg = computed(() => defaultRound(percent.value * 10));

        const mg1 = ref(190);
        const percentage1 = computed(() => defaultRound(mg.value / 10));

        const totalVolume = ref(10);
        const density = ref(1.04);
        const totalTHC = ref(2500);

        const mgPerML = computed(() => defaultRound(totalTHC.value / totalVolume.value));
        const mgPerG = computed(() => defaultRound(mgPerML.value / density.value));
        const percentage2 = computed(() => defaultRound(mgPerG.value / 10));


        const totalWeight = ref(1.2);
        const totalTHC1 = ref(256);

        const mgPerGram = computed(() => defaultRound(totalTHC.value / totalWeight.value));
        const thcPercentage = computed(() => defaultRound(mgPerGram.value / 10));
  
      return { percent, mg, mg1, percentage1, totalVolume, density, totalTHC, mgPerML, mgPerG, percentage2, totalWeight, totalTHC1, mgPerGram, thcPercentage, t: translations.t };
    },
  };
  </script>
  